import {
  IData_Network_Facebook,
  IData_Network_Facebook_Groups,
  IData_Network_Twitter,
  IData_Network_LinkedIn,
  IData_Network_Instagram,
  IData_Network,
  IData_Campaign_Mode_Network,
  IData_Campaign_Mode_Standalone,
  IData_Campaign_Mode,
  IData_Post_State_Scheduled,
  IData_Post_State_Generating,
  IData_Post_State_Generated,
  IData_Post_State_Approved,
  IData_Post_State_Rejected,
  IData_Post_State_Localising,
  IData_Post_State_Localised,
  IData_Post_State_Cancelled,
  IData_Post_State_Posted,
  IData_Post_State_Posting,
  IData_Post_State_Error,
  IData_Post_State,
  IData_Post_Type,
  IData_Post_Type_Original,
  IData_Post_Type_Localised,
} from '../types/schema/marketing'

export const MARKETING_NETWORK_FACEBOOK: IData_Network_Facebook = 'facebook'
export const MARKETING_NETWORK_FACEBOOK_GROUPS: IData_Network_Facebook_Groups = 'fbg'
export const MARKETING_NETWORK_TWITTER: IData_Network_Twitter = 'twitter'
export const MARKETING_NETWORK_LINKEDIN: IData_Network_LinkedIn = 'linkedin'
export const MARKETING_NETWORK_INSTAGRAM: IData_Network_Instagram = 'instagram'

export const MARKETING_NETWORKS: IData_Network[] = [
  MARKETING_NETWORK_FACEBOOK,
  MARKETING_NETWORK_FACEBOOK_GROUPS,
  MARKETING_NETWORK_TWITTER,
  MARKETING_NETWORK_LINKEDIN,
  MARKETING_NETWORK_INSTAGRAM,
]

export const MARKETING_NETWORK_TITLES: Record<IData_Network, string> = {
  [MARKETING_NETWORK_FACEBOOK]: 'Facebook',
  [MARKETING_NETWORK_FACEBOOK_GROUPS]: 'Facebook Groups',
  [MARKETING_NETWORK_TWITTER]: 'Twitter',
  [MARKETING_NETWORK_LINKEDIN]: 'LinkedIn',
  [MARKETING_NETWORK_INSTAGRAM]: 'Instagram',
}

export const MARKETING_NETWORK_COLORS: Record<IData_Network, string> = {
  [MARKETING_NETWORK_FACEBOOK]: '#1877F2',
  [MARKETING_NETWORK_FACEBOOK_GROUPS]: '#1877F2',
  [MARKETING_NETWORK_TWITTER]: '#1D9BF0',
  [MARKETING_NETWORK_LINKEDIN]: '#1D9BF0',
  [MARKETING_NETWORK_INSTAGRAM]: '#1D9BF0',  
}

export const MARKETING_CAMPAIGN_MODE_NETWORK: IData_Campaign_Mode_Network = 'network'
export const MARKETING_CAMPAIGN_MODE_STANDALONE: IData_Campaign_Mode_Standalone = 'standalone'

export const MARKETING_CAMPAIGN_MODES: IData_Campaign_Mode[] = [
  MARKETING_CAMPAIGN_MODE_NETWORK,
  MARKETING_CAMPAIGN_MODE_STANDALONE,
]

export const MARKETING_CAMPAIGN_MODE_TITLES: Record<IData_Campaign_Mode, string> = {
  [MARKETING_CAMPAIGN_MODE_NETWORK]: 'Whole Network',
  [MARKETING_CAMPAIGN_MODE_STANDALONE]: 'Standalone',
}

export const MARKETING_POST_STATE_SCHEDULED: IData_Post_State_Scheduled = 'scheduled'
export const MARKETING_POST_STATE_GENERATING: IData_Post_State_Generating = 'generating'
export const MARKETING_POST_STATE_GENERATED: IData_Post_State_Generated = 'generated'
export const MARKETING_POST_STATE_APPROVED: IData_Post_State_Approved = 'approved'
export const MARKETING_POST_STATE_REJECTED: IData_Post_State_Rejected = 'rejected'
export const MARKETING_POST_STATE_CANCELLED: IData_Post_State_Cancelled = 'cancelled'
export const MARKETING_POST_STATE_LOCALISING: IData_Post_State_Localising = 'localising'
export const MARKETING_POST_STATE_LOCALISED: IData_Post_State_Localised = 'localised'
export const MARKETING_POST_STATE_POSTING: IData_Post_State_Posting = 'posting'
export const MARKETING_POST_STATE_POSTED: IData_Post_State_Posted = 'posted'
export const MARKETING_POST_STATE_ERROR: IData_Post_State_Error = 'error'

export const MARKETING_POST_STATES: IData_Post_State[] = [
  MARKETING_POST_STATE_SCHEDULED,
  MARKETING_POST_STATE_GENERATING,
  MARKETING_POST_STATE_GENERATED,
  MARKETING_POST_STATE_APPROVED,
  MARKETING_POST_STATE_REJECTED,
  MARKETING_POST_STATE_CANCELLED,
  MARKETING_POST_STATE_LOCALISING,
  MARKETING_POST_STATE_LOCALISED,
  MARKETING_POST_STATE_POSTING,
  MARKETING_POST_STATE_POSTED,
  MARKETING_POST_STATE_ERROR,
]

export const MARKETING_POST_STATE_TITLES: Record<IData_Post_State, string> = {
  [MARKETING_POST_STATE_SCHEDULED]: 'Scheduled',
  [MARKETING_POST_STATE_GENERATING]: 'Generating',
  [MARKETING_POST_STATE_GENERATED]: 'Generated',
  [MARKETING_POST_STATE_APPROVED]: 'Approved',
  [MARKETING_POST_STATE_REJECTED]: 'Rejected',
  [MARKETING_POST_STATE_CANCELLED]: 'Cancelled',
  [MARKETING_POST_STATE_LOCALISING]: 'Localising',
  [MARKETING_POST_STATE_LOCALISED]: 'Localised',
  [MARKETING_POST_STATE_POSTING]: 'Posting',
  [MARKETING_POST_STATE_POSTED]: 'Posted',
  [MARKETING_POST_STATE_ERROR]: 'Error',
}

export const MARKETING_POST_TYPE_ORIGINAL: IData_Post_Type_Original = 'original'
export const MARKETING_POST_TYPE_LOCALISED: IData_Post_Type_Localised = 'localised'

export const MARKETING_POST_TYPES: IData_Post_Type[] = [
  MARKETING_POST_TYPE_ORIGINAL,
  MARKETING_POST_TYPE_LOCALISED,
]

export const MARKETING_POST_TYPE_TITLES: Record<IData_Post_Type, string> = {
  [MARKETING_POST_TYPE_ORIGINAL]: 'Original',
  [MARKETING_POST_TYPE_LOCALISED]: 'Localised',
}

export const MARKETING_DAY_OF_WEEK_TITLES = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
]

export const MARKETING_MONTH_TITLES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]